import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationStyles = createGlobalStyle`
  @font-face {
      font-family: 'CustomArial';
      src: url(${CustomArial});
  }    
  .generated-images-holder-var8 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 700px;
  }
  .image-holder-var8 {
    width: 100%;
    display: flex;
    position: relative;
    flex-direction: column;
    height: 883px;
  }
  .top-text-var8 {
    width: 100%;
    background-color: white;
    padding: 24px 35px;
    font-size: 41px;
    line-height: 1.25;
    color: #1C2327;
    font-family: CustomArial;
  }
  .bottom-text-var8 {
    position: absolute;
    bottom: 52px;
    margin: auto;
    left: 0;
    right: 0;
    font-size: 38px;
    line-height: 1.15;
    letter-spacing: 0.1px;
    color: #000;
    font-weight: 600;
    text-align: center;
    font-family: CustomArial;
    z-index: 1;
    p {
      background-color: white;
      display: inline-block;
      margin: 0;
      padding: 16px 41px 18px;
    }
  }
  .image-wrap-var8 {
    position: relative;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
  }
  .full-image-var8 {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .actual-photo-var8 {
    position: absolute;
    right: -80px;
    bottom: calc(50% - 24px);
    height: 47px;
    transform: rotate(90deg);
  }
  .ai-tag-var8 {
    position: absolute;
    right: -50px;
    bottom: calc(50% - 20px);
    transform: rotate(90deg);
    height: 47px;
    &--generated {
      right: -45px;
    }
    &--assisted {
      right: -32px;
    }
  }
  .watermark-var8 {
    position: absolute;
    bottom: 10px;
    right: 20px;
    z-index: 1;
  }
`;

export default VariationStyles;
